import { render, staticRenderFns } from "./role_form.vue?vue&type=template&id=57728fda&"
import script from "./role_form.vue?vue&type=script&lang=js&"
export * from "./role_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports